
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#D6DBEA","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"stroke-width":"2"}},[_c('path',{attrs:{"d":"M56.5 49.972L53.52 45.5V35c0-4-7.6-8.278-10.5-10.5m3.86 13.088l-7.296-5.848a2.606 2.606 0 10-3.686 3.686l7.066 7.974v5c0 2.362 3.376 6.09 3.376 6.09"}}),_c('path',{attrs:{"d":"M37.02 54.5H14.268a2.75 2.75 0 01-2.748-2.75v-39.5a2.75 2.75 0 012.748-2.75h26c1.52 0 2.75 1.23 2.752 2.75v22.244"}}),_c('path',{attrs:{"d":"M31.02 36.5h-12a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5h18m-19.5-6h16.5m-7.5-6v12"}})]),_c('path',{attrs:{"d":"M22.633 22.687h5.876m1.758-3.526a2.35 2.35 0 10-4.7 0v5.29c0 1.947-.404 4.113-2.351 4.113h7.051","stroke-width":"1.714"}})])])
          )
        }
      }
    